//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TemplateClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetTemplateQueryParameters = {
  id: number ;
}

export type PatchTemplateQueryParameters = {
  id: number ;
}

export type DeleteTemplateQueryParameters = {
  id: number ;
  allVersions?: boolean | undefined ;
}

export type GetVersionHistoryTemplateQueryParameters = {
  id: number ;
}

export type SearchTemplateQueryParameters = {
  isExported?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type UpdateProjectFileTemplateMutationParameters = {
  original?: Types.FileParameter | null | undefined ;
  modified?: Types.FileParameter | null | undefined ;
  project?: Types.FileParameter | null | undefined ;
}

export function deferCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/templates/defer";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deferCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'TemplateClient',
      'deferCreate',
    ]);
}

export function useDeferCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Types.CreateTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TemplateDto, unknown, Types.CreateTemplateDto, TContext> {
  const key = deferCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateTemplateDto) => Client.deferCreate(dto),
    mutationKey: key,
  });
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetTemplateQueryParameters;

    return trimArrayEnd([
        'TemplateClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'TemplateClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.TemplateDto, TError = unknown>(dto: GetTemplateQueryParameters, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.TemplateDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.TemplateDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TemplateDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetTemplateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TemplateDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'TemplateClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Types.UpdateTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TemplateDto, unknown, Types.UpdateTemplateDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateTemplateDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchTemplateQueryParameters & {
  dto: Types.UpdateTemplateDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchTemplateQueryParameters}): UseMutationResult<Types.TemplateDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deleteUrl(id: number, allVersions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/templates/{id}?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (allVersions === null)
    throw new Error("The parameter 'allVersions' cannot be null.");
else if (allVersions !== undefined)
    url_ += "allVersions=" + encodeURIComponent("" + allVersions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id: number, allVersions?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'TemplateClient',
      'delete',
      id as any,
      allVersions as any,
    ]);
}

export function useDeleteMutation<TContext>(id: number, allVersions?: boolean | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id, allVersions);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id, allVersions),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteTemplateQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteTemplateQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!, options?.parameters?.allVersions!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!, data.allVersions ?? options?.parameters?.allVersions!),
  mutationKey: key,
});
}
  
export function getVersionHistoryUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/templates/{id}/versions";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getVersionHistoryDefaultOptions: Omit<UseQueryOptions<Types.TemplateVersionHistoryItemDto[], unknown, Types.TemplateVersionHistoryItemDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TemplateVersionHistoryItemDto[], unknown, Types.TemplateVersionHistoryItemDto[]>, 'queryFn'>> = {
};
export function getGetVersionHistoryDefaultOptions() {
  return getVersionHistoryDefaultOptions;
};
export function setGetVersionHistoryDefaultOptions(options: typeof getVersionHistoryDefaultOptions) {
  getVersionHistoryDefaultOptions = options;
}

export function getVersionHistoryQueryKey(id: number): QueryKey;
export function getVersionHistoryQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetVersionHistoryTemplateQueryParameters;

    return trimArrayEnd([
        'TemplateClient',
        'getVersionHistory',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'TemplateClient',
        'getVersionHistory',
        ...params
      ]);
  }
}
export function __getVersionHistory(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getVersionHistory(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetVersionHistoryQuery<TSelectData = Types.TemplateVersionHistoryItemDto[], TError = unknown>(dto: GetVersionHistoryTemplateQueryParameters, options?: Omit<UseQueryOptions<Types.TemplateVersionHistoryItemDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetVersionHistoryQuery<TSelectData = Types.TemplateVersionHistoryItemDto[], TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.TemplateVersionHistoryItemDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetVersionHistoryQuery<TSelectData = Types.TemplateVersionHistoryItemDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TemplateVersionHistoryItemDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetVersionHistoryTemplateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TemplateVersionHistoryItemDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getVersionHistory(context, axiosConfig) : __getVersionHistory,
    queryKey: getVersionHistoryQueryKey(id),
    ...getVersionHistoryDefaultOptions as unknown as Omit<UseQueryOptions<Types.TemplateVersionHistoryItemDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetVersionHistoryData(queryClient: QueryClient, updater: (data: Types.TemplateVersionHistoryItemDto[] | undefined) => Types.TemplateVersionHistoryItemDto[], id: number) {
  queryClient.setQueryData(getVersionHistoryQueryKey(id),
    updater
  );
}

export function setGetVersionHistoryDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TemplateVersionHistoryItemDto[] | undefined) => Types.TemplateVersionHistoryItemDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function searchUrl(isExported?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/templates?";
if (isExported !== undefined && isExported !== null)
    url_ += "IsExported=" + encodeURIComponent("" + isExported) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfTemplateListItemDto, unknown, Types.PagedResultOfTemplateListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfTemplateListItemDto, unknown, Types.PagedResultOfTemplateListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchTemplateQueryParameters): QueryKey;
export function searchQueryKey(isExported?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { isExported, offset, limit, sortBy, sortOrder,  } = params[0] as SearchTemplateQueryParameters;

    return trimArrayEnd([
        'TemplateClient',
        'search',
        isExported as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'TemplateClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as boolean | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfTemplateListItemDto, TError = unknown>(dto: SearchTemplateQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfTemplateListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfTemplateListItemDto, TError = unknown>(isExported?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfTemplateListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfTemplateListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfTemplateListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let isExported: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ isExported, offset, limit, sortBy, sortOrder,  } = params[0] as SearchTemplateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [isExported, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfTemplateListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(isExported, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfTemplateListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfTemplateListItemDto | undefined) => Types.PagedResultOfTemplateListItemDto, isExported?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(isExported, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfTemplateListItemDto | undefined) => Types.PagedResultOfTemplateListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getFoldersUrl(): string {
  let url_ = getBaseUrl() + "/api/templates/folder";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFoldersDefaultOptions: Omit<UseQueryOptions<Types.ProjectElement[], unknown, Types.ProjectElement[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProjectElement[], unknown, Types.ProjectElement[]>, 'queryFn'>> = {
};
export function getGetFoldersDefaultOptions() {
  return getFoldersDefaultOptions;
};
export function setGetFoldersDefaultOptions(options: typeof getFoldersDefaultOptions) {
  getFoldersDefaultOptions = options;
}

export function getFoldersQueryKey(): QueryKey;
export function getFoldersQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TemplateClient',
      'getFolders',
    ]);
}
export function __getFolders(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getFolders(
axiosConfig    );
}

export function useGetFoldersQuery<TSelectData = Types.ProjectElement[], TError = unknown>(options?: Omit<UseQueryOptions<Types.ProjectElement[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFoldersQuery<TSelectData = Types.ProjectElement[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProjectElement[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProjectElement[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getFolders(context, axiosConfig) : __getFolders,
    queryKey: getFoldersQueryKey(),
    ...getFoldersDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProjectElement[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetFoldersData(queryClient: QueryClient, updater: (data: Types.ProjectElement[] | undefined) => Types.ProjectElement[], ) {
  queryClient.setQueryData(getFoldersQueryKey(),
    updater
  );
}

export function setGetFoldersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProjectElement[] | undefined) => Types.ProjectElement[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchFoldersUrl(): string {
  let url_ = getBaseUrl() + "/api/templates/folder";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchFoldersMutationKey(): MutationKey {
  return trimArrayEnd([
      'TemplateClient',
      'patchFolders',
    ]);
}

export function usePatchFoldersMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProjectElement[], unknown, Types.PatchFoldersDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectElement[], unknown, Types.PatchFoldersDto, TContext> {
  const key = patchFoldersMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchFoldersDto) => Client.patchFolders(dto),
    mutationKey: key,
  });
}
  
export function updateProjectFileUrl(): string {
  let url_ = getBaseUrl() + "/api/templates/update-project-file";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateProjectFileMutationKey(): MutationKey {
  return trimArrayEnd([
      'TemplateClient',
      'updateProjectFile',
    ]);
}

export function useUpdateProjectFileMutation<TContext>(options?: Omit<UseMutationOptions<Types.FileResponse, unknown, UpdateProjectFileTemplateMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileResponse, unknown, UpdateProjectFileTemplateMutationParameters, TContext> {
  const key = updateProjectFileMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateProjectFileTemplateMutationParameters: UpdateProjectFileTemplateMutationParameters) => Client.updateProjectFile(updateProjectFileTemplateMutationParameters.original, updateProjectFileTemplateMutationParameters.modified, updateProjectFileTemplateMutationParameters.project),
    mutationKey: key,
  });
}